<template>
  <form id="paypal_form" class="needs-validation" name="contact_form" novalidate>


    <div class="row mb-30">
      <div class="form-check col-md-12">
        <input type="checkbox" v-model="register.isGift" class="form-check-input checkbox-theme-colored" id="chkGift" />
        <label class="form-check-label text-theme-colored" for="chkGift"><i style="font-size: 25px" class="fa fa-gift"></i> REGALA IL PROGRAMMA</label>
      </div>
    </div>

    
    <div v-if="register.isGift">
      
        <hr />

        <h4>Fai un regalo a...</h4>

      <div class="row">
        <div class="form-group col-md-6">
          <label>Nome e secondo nome</label>
          <input type="text" v-model="register.nameGift" v-bind:required="register.isGift ? true : false" class="form-control" />
        </div>
        <div class="form-group col-md-6">
          <label>Cognome</label>
          <input type="text" v-model="register.surnameGift" v-bind:required="register.isGift ? true : false" class="form-control" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label>Email</label>
          <input type="email" v-model="register.emailGift" id="emailGiftField" v-bind:required="register.isGift ? true : false" class="form-control" />
        </div>
        <div class="form-group col-md-12">
          <label>Conferma Email</label>
          <input type="email" v-model="register.emailRepeatGift" id="emailGiftRepeatField" v-bind:required="register.isGift ? true : false" class="form-control" />
        </div>
      </div>
      
        <hr />

      <h4 v-if="!loggedIn">Informazioni di fatturazione</h4>

    </div>

    <div v-if="!loggedIn || registrDataMissing">
  
      <div class="row">
        <div class="form-group col-md-6">
          <label>Nome e secondo nome</label>
          <input type="text" v-model="register.name" required class="form-control" />
        </div>
        <div class="form-group col-md-6">
          <label>Cognome</label>
          <input type="text" v-model="register.surname" required class="form-control" />
        </div>
      </div>
      <div class="row" v-if="!loggedIn">
        <div class="form-group col-md-12">
          <label>Email</label>
          <input type="email" v-model="register.email" id="emailField" required class="form-control" />
        </div>
        <div class="form-group col-md-12" v-if="!register.isGift">
          <label>Conferma Email</label>
          <input type="email" v-model="register.emailRepeat" id="emailRepeatField" required class="form-control" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label>Indirizzo</label>
          <input type="text" v-model="register.address" required class="form-control" />
        </div>
        <div class="form-group col-md-6">
          <label>CAP</label>
          <input type="text" v-model="register.cap" required class="form-control" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label>Città</label>
          <input type="text" v-model="register.city" required class="form-control" />
        </div>
        <div class="form-group col-md-6">
          <label>Provincia</label>
          <input type="text" v-model="register.province" required class="form-control" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label>Codice fiscale</label>
          <input
            type="text"
            v-model="register.fiscalCode"
            minlength="16"
            required
            class="form-control"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Numero di telefono</label>
          <input type="text" v-model="register.phone" required class="form-control" />
        </div>
      </div>
      <div class="row" v-if="!loggedIn">
        <div class="form-check col-md-12">
          <input type="checkbox" v-model="register.privacy" required class="form-check-input" id="chkPrivacy" />
          <label class="form-check-label"  for="chkPrivacy">Accetto le condizioni di privacy <a class="text-theme-colored" target="_blank" href="/privacy">Leggi qui</a></label>
        </div>
        <div class="form-check col-md-12">
          <input type="checkbox"  v-model="register.condition" required class="form-check-input" id="chkConditions" />
          <label class="form-check-label" for="chkConditions">Accetto i termini e condizioni <a class="text-theme-colored" target="_blank" href="/terms">Leggi qui</a></label>
        </div>
      </div>
    </div>

    <div class="row pt-40">
      <div class="col-12">
        <div id="paypalButton"></div>
      </div>
    </div>

    <div class="row">
      <div class="alert alert-danger" v-if="error">{{ error }}</div>
    </div>
  </form>
</template>


<style scoped>
#paypal_form.was-validated .form-control:invalid {
  border-color: #ee163b;
}

#paypal_form.was-validated .form-check-input:invalid {
  outline: 2px solid red;
}

.form-check-input{
margin-right: 1rem;
    width: 1.2rem;
    height: 1.2rem;
}

.form-check-label{
  vertical-align: super;
}
    
</style>

<script>
import axios from "axios";
import braintree from "braintree-web";
import paypal from "paypal-checkout";

export default {
  name: "PaypalForm",
  props: ["amount", "IdProgram", "MonthsSelected", "discountCode", "userinfo"],
  watch: {
    userinfo: {
      immediate: true,
      handler(newValue) {
        if(newValue){
          this.register.name = newValue.Name;
          this.register.email = newValue.email;
          this.register.emailRepeat = newValue.email;
          this.register.surname = newValue.Surname;
          this.register.address = newValue.Address;
          this.register.cap = newValue.CAP;
          this.register.city = newValue.City;
          this.register.province = newValue.Province;
          this.register.fiscalCode = newValue.FiscalCode;
          this.register.phone = newValue.Phone;
          this.register.privacy = true;
          this.register.condition = true;

          if (((newValue.Name ?? '') == '') ||
          ((newValue.Surname ?? '') == '')||
          ((newValue.Address ?? '') == '')||
          ((newValue.CAP ?? '') == '')||
          ((newValue.City ?? '') == '')||
          ((newValue.Province ?? '') == '')||
          ((newValue.FiscalCode ?? '') == '')||
          ((newValue.Phone ?? '') == '')) {
              this.registrDataMissing = true;
              console.log("Register data missing")
          }
        }
      }
    }
  },
  data() {
    return {
      hostedFieldInstance: false,
      nonce: "",
      loggedIn:
        localStorage.getItem("token") != undefined ||
        localStorage.getItem("token") != null,
      error: "",
      registrDataMissing: false,
      register: {
        isGift: false,
        nameGift: undefined,
        surnameGift: undefined,
        emailGift: undefined,
        emailRepeatGift: undefined,
        email: "",
        emailRepeat: "",
        name: "",
        surname: "",
        address: undefined,
        cap: undefined,
        city: undefined,
        province: undefined,
        fiscalCode: undefined,
        phone: undefined,
        privacy: false,
        condition: false,
      },
    };
  },
  methods: {
    payWithCreditCard() {
      if (this.hostedFieldInstance) {
        this.hostedFieldInstance
          .tokenize()
          .then((payload) => {
            console.log(payload);
            this.nonce = payload.nonce;
          })
          .catch((err) => {
            console.error(err);
            this.error = err;
          });
      }
    },
    checkEmailBeforePayment(email) {
      const normalizedEmail = email.toLowerCase().trim();
      const url = `${process.env.VUE_APP_API_URL}/user/checkemail?email=${encodeURIComponent(normalizedEmail)}`;
      return axios
        .get(url)
        .then((response) => {
          const data = response.data;
          if (data.exists) {
            const message =
              "⚠️ Un account con questa email è già registrato nel nostro sistema. Esegui la login prima di fare l'acquisto. Se hai dimenticato la password, puoi ripristinarla dalla pagina di login. Altrimenti, usa un'altra email per creare un nuovo account.";
            this.error = message;
            return Promise.reject(new Error(message));
          }
          this.error = "";
          return Promise.resolve();
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const message = "L'email inserita non è valida.";
            this.error = message;
            return Promise.reject(new Error(message));
          }
          if (err.message && err.message.includes("account")) {
            return Promise.reject(err);
          }
          console.error("Email verification failed", err);
          const message =
            "Impossibile verificare l'email. Riprova più tardi.";
          this.error = message;
          return Promise.reject(new Error(message));
        });
    },
  },
  mounted() {
    braintree.client
      .create({
        authorization: process.env.VUE_APP_BRAINTREE_APIKEY,
      })
      .then((clientInstance) => {
        return Promise.all([
          // braintree.hostedFields.create(options),
          braintree.paypalCheckout.create({ client: clientInstance }),
        ]);
      })
      .then((instances) => {
        //const hostedFieldInstance = instances[0];
        const paypalCheckoutInstance = instances[0];

        // Use hostedFieldInstance to send data to Braintree
        //this.hostedFieldInstance = hostedFieldInstance;

        return paypal.Button.render(
          {
            env: process.env.VUE_APP_BRAINTREE_ENV_TYPE,
            locale: "it_IT",
            funding: {
              allowed: [paypal.FUNDING.CARD],
            },
            style: {
              color: "blue",
              label: "paypal",
              size: "responsive",
              shape: "rect",
              fundingicons: "true",
              tagline: "false",
            },
            onClick: () => {
                var form = document.getElementById("paypal_form");
                form.classList.add("was-validated");
            },
            validate: (actions) => {
              if (!this.loggedIn || this.registrDataMissing  || this.register.isGift) {
                var form = document.getElementById("paypal_form");
                var data = this;
                
                form.addEventListener(
                  "change",
                  function () {
                    var canGoAhead = false;
                    
                    if(data.register){
                      if(data.register.isGift){
                          if(data.register.emailGift != data.register.emailRepeatGift)
                          {
                            document.getElementById('emailGiftField').setCustomValidity("Invalid field.");
                            document.getElementById("emailGiftRepeatField").setCustomValidity('Email not match');
                          }
                          else if(data.register.emailGift == data.register.emailRepeatGift){
                            canGoAhead = true;
                            document.getElementById('emailGiftField').setCustomValidity("");
                            document.getElementById("emailGiftRepeatField").setCustomValidity("");
                          }
                      }
                      else if(!data.loggedIn){
                        if(data.register.email != data.register.emailRepeat)
                        {
                          document.getElementById('emailField').setCustomValidity("Invalid field.");
                          document.getElementById("emailRepeatField").setCustomValidity('Email not match');
                        }
                        else if(data.register.email == data.register.emailRepeat){
                          canGoAhead = true;
                          document.getElementById('emailField').setCustomValidity("");
                          document.getElementById("emailRepeatField").setCustomValidity("");
                        }
                      }else if(data.loggedIn){
                        canGoAhead = true;
                      }
                    }
                    
                    if (form.checkValidity() && canGoAhead) {
                      actions.enable();
                    } else {
                      actions.disable();
                    }
                  },
                  true
                );

                actions.disable();
              }
            },
            payment: () => {
              const paymentAllowed =
                (this.register.email != "" &&
                  (this.register.email == this.register.emailRepeat ||
                    this.register.emailGift == this.register.emailRepeatGift) &&
                  this.register.name != "" &&
                  this.register.surname != "") ||
                this.loggedIn;

              if (!paymentAllowed) {
                console.log("ERROR");
                return null;
              }

              // Check email solo se utente non loggato, prima di creare il pagamento
              if (!this.loggedIn) {
                return this.checkEmailBeforePayment(this.register.email).then(() => {
                  console.log("START PAYMENT");
                  return paypalCheckoutInstance.createPayment({
                    flow: "checkout",
                    intent: "sale",
                    amount: parseFloat(this.amount),
                    displayName: "SARAH FITNESS",
                    currency: "EUR",
                  });
                }).catch(() => {
                  // Se il check fallisce, PayPal non apre la finestra
                  return null;
                });
              }

              console.log("START PAYMENT");
              return paypalCheckoutInstance.createPayment({
                flow: "checkout",
                intent: "sale",
                amount: parseFloat(this.amount),
                displayName: "SARAH FITNESS",
                currency: "EUR",
              });
            },
            onAuthorize: (data) => {
              console.log(data);
              return paypalCheckoutInstance
                .tokenizePayment(data)
                .then((payload) => {
                  console.log(payload);
                  this.error = "";
                  this.nonce = payload.nonce;

                  var obj = {
                    clientID: payload.details.payerId,
                    nonce: payload.nonce,
                    // nonce: 'fake-paypal-one-time-nonce',
                    username: this.register.email,
                    email: this.register.email.toLowerCase().trim(),
                    isGift: this.register.isGift,
                    name: this.register.name,
                    surname: this.register.surname,
                    emailGift: this.register.emailGift ? this.register.emailGift.toLowerCase().trim() : undefined,
                    nameGift: this.register.nameGift,
                    surnameGift: this.register.surnameGift,
                    IDProgram: this.IdProgram,
                    DiscountCode: this.discountCode,
                    MonthOption: this.MonthsSelected,
                    address: this.register.address,
                    cap: this.register.cap,
                    city: this.register.city,
                    province: this.register.province,
                    fiscalCode: this.register.fiscalCode,
                    phone: this.register.phone,
                    privacy: this.register.privacy,
                    condition: this.register.condition,
                  };

                  axios
                    .post(process.env.VUE_APP_API_URL + "/checkout", obj)
                    .then((response) => {
                      console.log(response);
                      if (response.data.Ok == true) {
                        //PAYMENT OK
                        this.$emit("paymentCompleted");
                      }
                      else {
                        //PAYMENT OK
                        this.$emit("paymentNotCompleted", response.data.Error);
                      }
                    });
                });
            },
            onCancel: (data) => {
              console.log(data);
              console.log("Payment Cancelled");
            },
            onError: (err) => {
              console.error(err);
              // Non sovrascrivere l'errore se è già stato impostato dal check email
              if (!this.error || this.error === "") {
                this.error =
                  "C'è stato un errore in fase di pagamento, ricaricare la pagina e riprovare";
              }
            },
          },
          "#paypalButton"
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
